import {config} from "@onflow/config"
import {resolve} from "@onflow/sdk"

config().put("sdk.resolve", resolve)
